var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIrmIconDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3059 5.33325C19.3854 5.33325 19.4524 5.38473 19.4725 5.45482L19.4787 5.49884V10.5004C19.4787 10.5769 19.5326 10.6411 19.6058 10.6604L19.6518 10.6663H24.8713C24.9508 10.6663 25.0178 10.7178 25.0379 10.7879L25.0441 10.8319L25.0439 25.9702C25.0439 26.2719 24.8671 26.534 24.6073 26.6666H7.39317C7.13338 26.534 6.95652 26.2719 6.95652 25.9702V6.12168C6.95652 5.68624 7.32486 5.33325 7.77923 5.33325H19.3059ZM20.3136 5.72616C20.3136 5.58111 20.4964 5.50858 20.6036 5.61097L24.7543 9.58836C24.8614 9.69102 24.7854 9.86621 24.634 9.86621H20.4834C20.3896 9.86621 20.3136 9.79342 20.3136 9.70356V5.72616Z",
    fill: "#6F7687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrmIconDocuments);
export default __webpack_public_path__ + "static/media/irm-icon-documents.094ef71bd2a101575f985abfd480307d.svg";
export { ForwardRef as ReactComponent };